<template>
    <v-card outlined class="scenario">
        <v-card-subtitle class="black--text header">
            <slot name="scenario"></slot>
        </v-card-subtitle>
        <v-card-text class="black--text">
            <v-row class="field" no-gutters>
                <v-col cols="12" sm="2" class="name">
                    metrics
                </v-col>
                <v-col cols="12" sm="10" class="value">
                    <slot name="metrics"></slot>
                </v-col>
            </v-row>
            <v-row class="field" no-gutters>
                <v-col cols="12" sm="2" class="name">
                    Threshold-based inspection
                </v-col>
                <v-col cols="12" sm="10" class="value">
                    <slot name="threshold"></slot>
                </v-col>
            </v-row>
            <v-row v-if="correlation" class="field" no-gutters>
                <v-col cols="12" sm="2" class="name">
                    Correlation-based inspection
                </v-col>
                <v-col cols="12" sm="10" class="value">
                    <slot name="correlation"></slot>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    props: {
        correlation: Boolean,
    },
};

</script>

<style scoped>

.scenario {
    margin: 36px 0;
}

.scenario  .header {
    font-size: 16px;
}

.scenario .field {
    /*flex-wrap: nowrap;*/
    border-bottom: 1px solid rgba(0,0,0,0.12);
    align-items: center;
}
.scenario .field:last-of-type {
    border-bottom: none;
}

.scenario .field .name {
    color: rgba(0,0,0,0.5);
    font-weight: 500;
    padding: 4px;
    font-size: 12px;
    text-transform: uppercase;
}

.scenario .field .value {
    padding: 4px;
    font-size: 14px;
    flex-grow: 2;
}
</style>
